// jobReducers.js

// Action types
export const SET_JOB_INFO = 'SET_JOB_INFO';
export const UPDATE_JOB_INFO = 'UPDATE_JOB_INFO';
export const CLEAR_JOB_INFO = 'CLEAR_JOB_INFO';

// Initial state
let initialJobInfo = {};
try {
  const jobInfoFromStorage = localStorage.getItem('jobInfo');
  if (jobInfoFromStorage) {
    initialJobInfo = JSON.parse(jobInfoFromStorage);
  }
} catch (error) {
  console.error('Failed to parse jobInfo from localStorage', error);
}

const initialState = {
  jobInfo: initialJobInfo,
};

// Reducer function
const jobReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case SET_JOB_INFO:
      newState = setJobInfo(state, action.payload);
      break;
    case UPDATE_JOB_INFO:
      newState = updateJobInfo(state, action.payload);
      break;
    case CLEAR_JOB_INFO:
      newState = clearJobInfo();
      break;
    default:
      newState = state;
  }

  // Update local storage
  localStorage.setItem('jobInfo', JSON.stringify(newState.jobInfo));

  return newState;
};

// Action creators



// Helper functions
const setJobInfo = (state, payload) => {
  const { jobInfo } = payload;
  return { ...state, jobInfo: jobInfo };
};

const updateJobInfo = (state, payload) => {
  const { updatedInfo } = payload;
  return { ...state, jobInfo: { ...state.jobInfo, ...updatedInfo } };
};

const clearJobInfo = () => {
  return { ...initialState }; // Reset to initial state
};

export default jobReducer;
